import { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import t from './utils/i18n.js';

const Categories = (props) => {
    const subCategories = (items) => {
        return (
            items.length ?
                <div className="category__sub-list">
                {items.map((item) => {
                    let name = window.mainCategories[item.id];
                    const categoryClass = classNames({
                        'category__sub': true,
                        'category__sub--disabled': !props.facets.subcategories[item.id]
                    });
                    return (
                    <label className={categoryClass} key={item.id}>
                        <span className="checkbox">
                            <input
                                name="sub-category"
                                type="checkbox"
                                onChange={(event) => {
                                    selectCategory(event, name, 'subCategory') ;
                                }}
                                checked={props.selectedSubCategory.includes(name)}
                            />
                            <span className="checkbox__indicator"></span>
                        </span> <span className="category__name category__name--sub">{name} {props.facets.subcategories[item.id] ? (<em className="category__sub-count">({props.facets.subcategories[item.id]})</em>) : ''}</span>
                    </label>
                    );
                })}
                </div>
            : ''
        );
    };

    const selectCategory = (event, name, type) => {
        let remove = !event.target.checked;
        props.setCategory(name, type, remove)();
    };

    const getSelectedCategory = () => {
        if (props.selectedCategory.length === 0) {
            return '';
        }
        return props.selectedCategory[props.selectedCategory.length - 1];
    };

    const category = Object.values(props.categories).map((item) => {
        const [categoryToggled, setCategoryToggled] = useState(null);

        const activeClass = classNames({
            category: true,
            'category--active': 
                (item.name === getSelectedCategory() && categoryToggled !== false) || 
                categoryToggled,
            'category--disabled': !props.facets.categories[item.id]
        });

        const toggleCategory = (event) => {
            event.preventDefault();
            setCategoryToggled(!categoryToggled);
        };

        const onCategoryChange = (event) => {
            selectCategory(event, item.name, 'category');
            setCategoryToggled(null);
        };

        return (
            <div className={activeClass} key={item.slug}>
                <label className={
                    classNames({
                        'category__main': true,
                        'category__main--no-children': !item.children.length,
                    })
                }>
                    <span className="checkbox">
                        <input
                            name="main-category"
                            type="checkbox"
                            onChange={(e) => onCategoryChange(e)}
                            checked={props.selectedCategory.includes(item.name)}
                            aria-labelledby={'category-' + item.slug}
                        />
                        <span className="checkbox__indicator"></span>
                    </span>
                    <span className="category__name" id={'category-' + item.slug}>{item.name}{props.facets.categories[item.id] ? ( <div className="category__count">{props.facets.categories[item.id]}</div>) : ''}</span>
                    {item.children.length ?
                        <button name="toggle-category" onClick={(e) => toggleCategory(e)} className="category__toggle" aria-label="Vis/skjul kategori"></button>
                        : ''
                    }
                </label>
                {subCategories(item.children)}
            </div>
        );
    });

    const selectedCategory = (
        <div>
            {/*
            <div className="breadcrumb">
                <button onClick={() => props.resetFilters()} className="breadcrumb__item">
                    {props.isRestplass ? 'Linjer med ledige plasser' : 'Alle linjer'}
                </button>
                <div className="breadcrumb__item breadcrumb__item--active">
                    {props.selectedCategory}
                </div>
            </div>
            */}
        </div>
    );

    const selectedSubCategory = (
        <div>
            <div className="breadcrumb">
                <button onClick={() => props.resetFilters()} className="breadcrumb__item">
                    {props.isRestplass ? 'Linjer med ledige plasser' : 'Alle linjer'}
                </button>
                <button onClick={props.setCategory('', 'subCategory')} className="breadcrumb__item">
                    {props.selectedCategory}
                </button>
                <div className="breadcrumb__item">
                    {props.selectedSubCategory}
                </div>
            </div>
        </div>
    );

    return (
        <div className="category__wrapper">
            {category}
        </div>
    );
};

Categories.propTypes = {
    categories: PropTypes.array,
    selectedSubCategory: PropTypes.array,
    selectedCategory: PropTypes.array,
    facets: PropTypes.object,
    setCategory: PropTypes.func,
    toggleCategory: PropTypes.func,
    resetFilters: PropTypes.func,
    isRestplass: PropTypes.bool,
    lang: PropTypes.string
};

export default Categories;
